/*
 * @Author: Tahiti
 * @Date: 2025-10-21 10:51:20
 * @LastEditors: Tahiti
 * @LastEditTime: 2026-01-06 22:58:00
 * @Description:
 * @FilePath: /weryai-web/locales/modules/homeView.ts
 */
export default {
    zh: {
        hot_models: '热门 AI 模型',
        workbench_title: '创造你所想象的一切',
        image_create: '图片生成',
        video_create: '视频生成',
        music_create: '音乐生成',
        ugc_create: '角色',
        ai_music: 'AI 音乐',
        ai_tools: '编辑工具',
        expand: '查看全部',
        collapse: '收起',
        create: '创建',
        text_to_image: '文生图',
        text_to_image_desc: '用自然语言生成图片',
        model: 'AI 模型',
        sora2_desc: '这是Sora2模型的描述',
        try: '体验',
        free_try_now: '免费体验',
        new: '新',
        audio: '音频',
        image: '图片',
        bannerVideoDesc1: '现实世界和音频模拟',
        bannerVideoDesc2: '高质量视频编辑',
        bannerVideoDesc3: '创意视频内容',
        bannerVideoDesc4: '高级AI视频创作',
        imageModels: 'AI 图片生成模型',
        imageModelsDesc:
            '探索强大的 AI 图片生成模型，从 Nano banana 到 Sora2 模型，满足您的所有创作需求。',
        videoModels: 'AI 视频生成模型',
        videoModelsDesc:
            '探索强大的 AI 视频生成模型，从 Google Veo 到 Seedance 模型，满足您的所有创作需求。',
        bannerImageDesc: '让你的想象力成为现实',
        bannerVideoCreateDesc: '即刻创作电影级视频',
        bannerMusicDesc: '一键创作专属音乐',
        bannerCharacterDesc: '与虚拟 AI 角色聊天',
        inspiration_title: '灵感',
        feed_hot: '热门灵感',
        feed_latest: '最新灵感',
        feed_hot_short: '热门',
        feed_latest_short: '最新',
        load_more_inspiration: '查看更多灵感',
        inspiration_badge_video: '视频',
        inspiration_badge_image: '图片',
    },
    en: {
        hot_models: 'Popular AI Models',
        workbench_title: 'Create Whatever You Imagine',
        image_create: 'Generate Image',
        video_create: 'Generate Video',
        music_create: 'Generate Music',
        ugc_create: 'Characters',
        ai_music: 'AI Music',
        ai_tools: 'Editor Toolkits',
        expand: 'View All',
        collapse: 'Collapse',
        create: 'Create',
        text_to_image: 'Text to Image',
        text_to_image_desc: 'Input prompt to create a image',
        model: 'AI Models',
        sora2_desc: "This is Sora2's Description",
        try: 'Try',
        free_try_now: 'Free Try Now',
        new: 'New',
        audio: 'Audio',
        image: 'Image',
        bannerVideoDesc1: 'Realistic world & audio simulation',
        bannerVideoDesc2: 'High-quality video editing',
        bannerVideoDesc3: 'Creative video content',
        bannerVideoDesc4: 'Advanced AI video creation',
        imageModels: 'AI Image Models',
        imageModelsDesc:
            'Explore powerful AI image generation models, from Nano banana to Sora2 models, meet your creative needs.',
        videoModels: 'AI Video Models',
        videoModelsDesc:
            'Explore our powerful AI video generation models, from Google Veo to Seedance models, meet your creative needs.',
        bannerImageDesc: 'Bring your imagination to life.',
        bannerVideoCreateDesc: 'Create cinematic videos instantly.',
        bannerMusicDesc: 'Create your own music with one click.',
        bannerCharacterDesc: 'Chat with virtual AI characters.',
        inspiration_title: 'Inspiration',
        feed_hot: 'Hot Inspiration',
        feed_latest: 'Latest Inspiration',
        feed_hot_short: 'Hot',
        feed_latest_short: 'Latest',
        load_more_inspiration: 'View More Inspiration',
        inspiration_badge_video: 'Video',
        inspiration_badge_image: 'Image',
    },
    ja: {
        hot_models: '人気のAIモデル',
        workbench_title: '想像したものを何でも創り出そう',
        image_create: '画像生成',
        video_create: 'ビデオ生成',
        music_create: '音楽生成',
        ugc_create: 'キャラクター',
        ai_music: 'AI ミュージック',
        ai_tools: '編集ツール',
        expand: 'すべて表示',
        collapse: '折りたたむ',
        create: '作成',
        text_to_image: 'テキストから画像',
        text_to_image_desc: '自然言語で画像を生成',
        model: 'モデル',
        try: '体験',
        free_try_now: '無料体験',
        new: '新',
        audio: '音声',
        image: '画像',
        bannerVideoDesc1: '現実世界とオーディオシミュレーション',
        bannerVideoDesc2: '高品質なビデオ生成',
        bannerVideoDesc3: '創造的なビデオコンテンツ',
        bannerVideoDesc4: '高度なAIビデオ制作',
        imageModels: 'AI 画像生成モデル',
        imageModelsDesc:
            '我々の強力なAI画像生成モデルを探索します。ナノバナナからSora2モデルまで、あなたの創造的なニーズを満たします。',
        videoModels: 'AI ビデオ生成モデル',
        videoModelsDesc:
            '我々の強力なAIビデオ生成モデルを探索します。Google VeoからSeedanceモデルまで、あなたの創造的なニーズを満たします。',
        bannerImageDesc: 'あなたの想像を現実に',
        bannerVideoCreateDesc: '映画のような動画を即座に作成',
        bannerMusicDesc: 'ワンクリックでオリジナル音楽を作成',
        bannerCharacterDesc: 'バーチャル AI キャラとチャット',
        sora2_desc: '物理学に基づいた正確なAI動画生成',
        inspiration_title: 'インスピレーション',
        feed_hot: '人気のインスピレーション',
        feed_latest: '最新のインスピレーション',
        feed_hot_short: '人気',
        feed_latest_short: '最新',
        load_more_inspiration: 'もっと見る',
        inspiration_badge_video: '動画',
        inspiration_badge_image: '画像',
    },

    ko: {
        hot_models: '인기 AI 모델',
        workbench_title: '상상하는 모든 것을 만들어 보세요',
        image_create: '이미지 생성',
        video_create: '비디오 생성',
        music_create: '음악 생성',
        ugc_create: '캐릭터',
        ai_music: 'AI 음악',
        ai_tools: '편집 도구',
        expand: '모두 보기',
        collapse: '접기',
        create: '만들기',
        text_to_image: '텍스트에서 이미지',
        text_to_image_desc: '자연어로 이미지 생성',
        try: '시도',
        free_try_now: '무료 시도',
        new: '새로운',
        audio: '오디오',
        image: '이미지',
        bannerVideoDesc1: '현실적인 세계와 오디온 시뮬레이션',
        bannerVideoDesc2: '고품질 비디오 생성',
        bannerVideoDesc3: '창의적인 비디오 콘텐츠',
        bannerVideoDesc4: '고급 AI 비디오 제작',
        imageModels: 'AI 이미지 생성 모델',
        imageModelsDesc:
            '우리의 강력한 AI 이미지 생성 모델을 탐험하세요. 나노바나나에서 Sora2 모델까지, 당신의 창의적인 요구를 충족시키세요.',
        videoModels: 'AI 비디오 생성 모델',
        videoModelsDesc:
            '우리의 강력한 AI 비디오 생성 모델을 탐험하세요. Google Veo에서 Seedance 모델까지, 당신의 창의적인 요구를 충족시키세요.',
        bannerImageDesc: '상상을 현실로 만들어 보세요',
        bannerVideoCreateDesc: '영화 같은 비디오를 즉시 제작',
        bannerMusicDesc: '한 번의 클릭으로 나만의 음악 만들기',
        bannerCharacterDesc: '가상 AI 캐릭터와 대화하세요',
        inspiration_title: '영감',
        feed_hot: '인기 영감',
        feed_latest: '최신 영감',
        feed_hot_short: '인기',
        feed_latest_short: '최신',
        load_more_inspiration: '더 많은 영감 보기',
        inspiration_badge_video: '비디오',
        inspiration_badge_image: '이미지',
        sora2_desc: '물리학 기반의 정확한 AI 비디오 생성',
        model: '모델',
    },
    tw: {
        hot_models: '熱門 AI 模型',
        workbench_title: '創造你所想像的一切',
        image_create: '圖片生成',
        video_create: '影片生成',
        music_create: '音樂生成',
        ugc_create: '角色',
        ai_tools: '編輯工具',
        expand: '查看全部',
        collapse: '收起',
        create: '建立',
        text_to_image: '文生圖',
        text_to_image_desc: '以自然語言生成圖片',
        model: 'AI 模型',
        sora2_desc: 'Sora2 模型介紹',
        try: '體驗',
        free_try_now: '免費體驗',
        new: '新',
        audio: '音訊',
        image: '圖片',
        bannerVideoDesc1: '真實世界與音訊模擬',
        bannerVideoDesc2: '高品質影片編輯',
        bannerVideoDesc3: '創意影片內容',
        bannerVideoDesc4: '進階 AI 影片創作',
        imageModels: 'AI 圖片生成模型',
        imageModelsDesc:
            '探索強大的 AI 圖片生成模型，從 Nano Banana 到 Sora2，滿足你的創作需求。',
        videoModels: 'AI 影片生成模型',
        videoModelsDesc:
            '探索強大的 AI 影片生成模型，從 Google Veo 到 Seedance，滿足你的創作需求。',
        bannerImageDesc: '讓想像成真',
        bannerVideoCreateDesc: '即刻創作電影級影片',
        bannerMusicDesc: '一鍵創作專屬音樂',
        bannerCharacterDesc: '與虛擬 AI 角色聊天',
        inspiration_title: '靈感',
        feed_hot: '熱門靈感',
        feed_latest: '最新靈感',
        feed_hot_short: '熱門',
        feed_latest_short: '最新',
        load_more_inspiration: '查看更多靈感',
        inspiration_badge_video: '影片',
        inspiration_badge_image: '圖片',
    },
    pl: {
        hot_models: 'Popularne modele AI',
        workbench_title: 'Twórz wszystko, co sobie wyobrazisz',
        image_create: 'Generowanie obrazów',
        video_create: 'Generowanie wideo',
        music_create: 'Generowanie muzyki',
        ugc_create: 'Postacie',
        ai_tools: 'Narzędzia edycji',
        expand: 'Zobacz wszystko',
        collapse: 'Zwiń',
        create: 'Utwórz',
        text_to_image: 'Tekst→Obraz',
        text_to_image_desc: 'Wpisz prompt, aby wygenerować obraz',
        model: 'Modele AI',
        sora2_desc: 'Opis modelu Sora2',
        try: 'Wypróbuj',
        free_try_now: 'Wypróbuj za darmo',
        new: 'Nowość',
        audio: 'Audio',
        image: 'Obraz',
        bannerVideoDesc1: 'Realistyczny świat i symulacja dźwięku',
        bannerVideoDesc2: 'Wysokiej jakości edycja wideo',
        bannerVideoDesc3: 'Kreatywne treści wideo',
        bannerVideoDesc4: 'Zaawansowane tworzenie wideo AI',
        imageModels: 'Modele obrazów AI',
        imageModelsDesc:
            'Poznaj potężne modele generowania obrazów AI, od Nano Banana po Sora2.',
        videoModels: 'Modele wideo AI',
        videoModelsDesc:
            'Poznaj nasze modele generowania wideo AI, od Google Veo po Seedance.',
        bannerImageDesc: 'Ożyw swoją wyobraźnię',
        bannerVideoCreateDesc: 'Twórz filmowe wideo natychmiast',
        bannerMusicDesc: 'Stwórz własną muzykę jednym kliknięciem',
        bannerCharacterDesc: 'Rozmawiaj z wirtualnymi postaciami AI',
        inspiration_title: 'Inspiracje',
        feed_hot: 'Popularne',
        feed_latest: 'Najnowsze',
        load_more_inspiration: 'Zobacz więcej',
        feed_hot_short: 'Popularne',
        feed_latest_short: 'Najnowsze',
        inspiration_badge_video: 'Wideo',
        inspiration_badge_image: 'Obraz',
    },
    es: {
        hot_models: 'Modelos de IA populares',
        workbench_title: 'Crea todo lo que imagines',
        image_create: 'Imagen de creación',
        video_create: 'Video de creación',
        music_create: 'Generación de música',
        ugc_create: 'Personajes',
        ai_music: 'Música IA',
        ai_tools: 'Herramientas de edición',
        expand: 'Ver todo',
        collapse: 'Contraer',
        create: 'Crear',
        text_to_image: 'Texto a imagen',
        text_to_image_desc: 'Ingrese un prompt para crear una imagen',
        try: 'Intentar',
        free_try_now: 'Probar gratis',
        new: 'Nuevo',
        audio: 'Audio',
        image: 'Imagen',
        bannerVideoDesc1: 'Contenido de video creativo',
        bannerVideoDesc2: 'Generación de video de alta calidad',
        bannerVideoDesc3: 'Contenido de video creativo',
        bannerVideoDesc4: 'Creación de video avanzada con IA',
        imageModels: 'Modelos de generación de imágenes AI',
        imageModelsDesc:
            'Explora nuestros potentes modelos de generación de imágenes AI, desde Nano banana hasta Sora2, para satisfacer tus necesidades creativas.',
        videoModels: 'Modelos de generación de videos AI',
        videoModelsDesc:
            'Explora nuestros potentes modelos de generación de videos AI, desde Google Veo hasta Seedance, para satisfacer tus necesidades creativas.',
        bannerImageDesc: 'Da vida a tu imaginación.',
        bannerVideoCreateDesc: 'Crea videos cinematográficos al instante.',
        bannerMusicDesc: 'Crea tu propia música con un clic.',
        bannerCharacterDesc: 'Chatea con personajes virtuales de IA.',
        inspiration_title: 'Inspiración',
        feed_hot: 'Inspiración popular',
        feed_latest: 'Última inspiración',
        feed_hot_short: 'Popular',
        feed_latest_short: 'Último',
        load_more_inspiration: 'Ver más inspiración',
        inspiration_badge_video: 'Vídeo',
        inspiration_badge_image: 'Imagen',
        sora2_desc: 'Generación de video IA con precisión física',
        model: 'Modelo',
    },
    fr: {
        hot_models: 'Modèles IA populaires',
        workbench_title: 'Créez tout ce que vous imaginez',
        image_create: "Création d'image",
        video_create: 'Création de vidéo',
        music_create: 'Génération de musique',
        ugc_create: 'Personnages',
        ai_music: 'Musique IA',
        ai_tools: "Outils d'édition",
        expand: 'Voir tout',
        collapse: 'Réduire',
        create: 'Créer',
        text_to_image: 'Texte à image',
        text_to_image_desc: 'Entrez un prompt pour créer une image',
        try: 'Essayer',
        free_try_now: 'Essayer gratuitement',
        new: 'Nouveau',
        audio: 'Audio',
        image: 'Image',
        bannerVideoDesc1: 'Contenu vidéo créatif',
        bannerVideoDesc2: 'Génération de vidéo de haute qualité',
        bannerVideoDesc3: 'Contenu vidéo créatif',
        bannerVideoDesc4: 'Création de vidéo avancée avec IA',
        imageModels: "Modèles de génération d'images AI",
        imageModelsDesc:
            "Explore nos modèles de génération d'images AI puissants, de Nano banana à Sora2, pour répondre à vos besoins créatifs.",
        videoModels: 'Modèles de génération de vidéos AI',
        videoModelsDesc:
            'Explore nos modèles de génération de vidéos AI puissants, de Google Veo à Seedance, pour répondre à vos besoins créatifs.',
        bannerImageDesc: 'Donnez vie à votre imagination.',
        bannerVideoCreateDesc: 'Créez des vidéos cinématiques instantanément.',
        bannerMusicDesc: 'Créez votre propre musique en un clic.',
        bannerCharacterDesc: 'Discutez avec des personnages IA virtuels.',
        inspiration_title: 'Inspiration',
        feed_hot: 'Inspiration tendance',
        feed_latest: 'Dernière inspiration',
        feed_hot_short: 'Tendance',
        feed_latest_short: 'Dernier',
        load_more_inspiration: 'Voir plus d\'inspiration',
        inspiration_badge_video: 'Vidéo',
        inspiration_badge_image: 'Image',
        sora2_desc: 'Génération de vidéo IA physiquement précise',
        model: 'Modèle',
    },
    de: {
        hot_models: 'Beliebte KI-Modelle',
        workbench_title: 'Erschaffe alles, was du dir vorstellst',
        image_create: 'Bild erstellen',
        video_create: 'Video erstellen',
        music_create: 'Musik erstellen',
        ugc_create: 'Charaktere',
        ai_music: 'KI Musik',
        ai_tools: 'Editor-Tools',
        expand: 'Alle anzeigen',
        collapse: 'Einklappen',
        create: 'Erstellen',
        text_to_image: 'Text zu Bild',
        text_to_image_desc:
            'Geben Sie einen Prompt ein, um ein Bild zu erstellen',
        try: 'Versuchen',
        free_try_now: 'Kostenlos versuchen',
        new: 'Neu',
        audio: 'Audio',
        image: 'Изображение',
        bannerVideoDesc1:
            'Создание видео с реалистичным миром и аудиосимуляцией',
        bannerVideoDesc2: 'Создание высококачественного видео',
        bannerVideoDesc3: 'Творческое видео-содержание',
        bannerVideoDesc4: 'Создание видео с использованием ИИ',
        imageModels: 'Модели генерации изображений AI',
        imageModelsDesc:
            'Исследуйте наши мощные модели генерации изображений AI, от Nano banana до Sora2, чтобы удовлетворить ваши творческие потребности.',
        videoModels: 'Модели генерации видео AI',
        videoModelsDesc:
            'Исследуйте наши мощные модели генерации видео AI, от Google Veo до Seedance, чтобы удовлетворить ваши творческие потребности.',
        bannerImageDesc: 'Erwecke deine Vorstellung zum Leben.',
        bannerVideoCreateDesc: 'Erstelle sofort filmreife Videos.',
        bannerMusicDesc: 'Erstelle deine eigene Musik mit einem Klick.',
        bannerCharacterDesc: 'Chatte mit virtuellen KI-Charakteren.',
        inspiration_title: 'Inspiration',
        feed_hot: 'Beliebte Inspiration',
        feed_latest: 'Neueste Inspiration',
        feed_hot_short: 'Beliebt',
        feed_latest_short: 'Neu',
        load_more_inspiration: 'Mehr Inspiration anzeigen',
        inspiration_badge_video: 'Video',
        inspiration_badge_image: 'Bild',
        sora2_desc: 'Physikalisch präzise KI-Videogenerierung',
        model: 'Modell',
    },
    ru: {
        hot_models: 'Популярные модели ИИ',
        workbench_title: 'Создавайте всё, что вы можете вообразить',
        image_create: 'Создание изображения',
        video_create: 'Создание видео',
        music_create: 'Создание музыки',
        ugc_create: 'Персонажи',
        ai_music: 'ИИ Музыка',
        ai_tools: 'Инструменты редактирования',
        expand: 'Показать все',
        collapse: 'Свернуть',
        create: 'Создать',
        text_to_image: 'Текст к изображению',
        text_to_image_desc: 'Введите prompt для создания изображения',
        try: 'Попробовать',
        free_try_now: 'Попробовать бесплатно',
        new: 'Новый',
        audio: 'Аудио',
        image: 'Изображение',
        bannerVideoDesc1:
            'Создание видео с реалистичным миром и аудиосимуляцией',
        bannerVideoDesc2: 'Создание высококачественного видео',
        bannerVideoDesc3: 'Творческое видео-содержание',
        bannerVideoDesc4: 'Создание видео с использованием ИИ',
        imageModels: 'Модели генерации изображений AI',
        imageModelsDesc:
            'Исследуйте наши мощные модели генерации изображений AI, от Nano banana до Sora2, чтобы удовлетворить ваши творческие потребности.',
        videoModels: 'Модели генерации видео AI',
        videoModelsDesc:
            'Исследуйте наши мощные модели генерации видео AI, от Google Veo до Seedance, чтобы удовлетворить ваши творческие потребности.',
        bannerImageDesc: 'Воплотите ваше воображение в жизнь.',
        bannerVideoCreateDesc:
            'Создавайте кинематографические видео мгновенно.',
        bannerMusicDesc: 'Создайте свою музыку одним кликом.',
        bannerCharacterDesc: 'Общайтесь с виртуальными AI-персонажами.',
        inspiration_title: 'Вдохновение',
        feed_hot: 'Популярное',
        feed_latest: 'Новое',
        feed_hot_short: 'Популярное',
        feed_latest_short: 'Новое',
        load_more_inspiration: 'Больше вдохновения',
        inspiration_badge_video: 'Видео',
        inspiration_badge_image: 'Изображение',
        sora2_desc: 'Физически точная генерация ИИ-видео',
        model: 'Модель',
    },
    pt: {
        hot_models: 'Modelos de IA populares',
        workbench_title: 'Crie qualquer coisa que quiser',
        image_create: 'Criação de imagem',
        video_create: 'Criação de vídeo',
        music_create: 'Criação de música',
        ugc_create: 'Personagens',
        ai_music: 'Música IA',
        ai_tools: 'Ferramentas de edição',
        expand: 'Ver tudo',
        collapse: 'Recolher',
        create: 'Criar',
        text_to_image: 'Texto para imagem',
        text_to_image_desc: 'Insira um prompt para criar uma imagem',
        try: 'Tentar',
        free_try_now: 'Tentar gratuitamente',
        new: 'Novo',
        audio: 'Áudio',
        image: 'Imagem',
        bannerVideoDesc1: 'Conteúdo de vídeo criativo',
        bannerVideoDesc2: 'Geração de vídeo de alta qualidade',
        bannerVideoDesc3: 'Conteúdo de vídeo criativo',
        bannerVideoDesc4: 'Criação de vídeo avançada com IA',
        imageModels: 'Modelos de geração de imagens AI',
        imageModelsDesc:
            'Explore nossos modelos de geração de imagens AI poderosos, de Nano banana a Sora2, para atender às suas necessidades criativas.',
        videoModels: 'Modelos de geração de vídeos AI',
        videoModelsDesc:
            'Explore nossos modelos de geração de vídeos AI poderosos, de Google Veo a Seedance, para atender às suas necessidades criativas.',
        bannerImageDesc: 'Dê vida à sua imaginação.',
        bannerVideoCreateDesc: 'Crie vídeos cinematográficos instantaneamente.',
        bannerMusicDesc: 'Crie sua própria música com um clique.',
        bannerCharacterDesc: 'Converse com personagens virtuais de IA.',
        inspiration_title: 'Inspiração',
        feed_hot: 'Inspiração popular',
        feed_latest: 'Última inspiração',
        feed_hot_short: 'Popular',
        feed_latest_short: 'Último',
        load_more_inspiration: 'Ver mais inspiração',
        inspiration_badge_video: 'Vídeo',
        inspiration_badge_image: 'Imagem',
        sora2_desc: 'Geração de vídeo IA fisicamente precisa',
        model: 'Modelo',
    },
    it: {
        hot_models: 'Modelli IA popolari',
        workbench_title: 'WeryAI - Crea tutto ciò che immagini.',
        image_create: 'Creazione immagine',
        video_create: 'Creazione video',
        music_create: 'Creazione musica',
        ugc_create: 'Personaggi',
        ai_music: 'Musica IA',
        ai_tools: 'Strumenti di editing',
        expand: 'Vedi tutto',
        collapse: 'Comprimi',
        create: 'Crea',
        text_to_image: 'Testo a immagine',
        text_to_image_desc: "Inserisci un prompt per creare un'immagine",
        try: 'Provare',
        free_try_now: 'Provare gratuitamente',
        new: 'Nuovo',
        audio: 'Audio',
        image: 'Immagine',
        bannerVideoDesc1: 'Contenuto video creativo',
        bannerVideoDesc2: 'Generazione di video di alta qualità',
        bannerVideoDesc3: 'Contenuto video creativo',
        bannerVideoDesc4: 'Creazione di video avanzata con IA',
        imageModels: 'Modelli di generazione di immagini AI',
        imageModelsDesc:
            'Esplora i nostri potenti modelli di generazione di immagini AI, da Nano banana a Sora2, per soddisfare le tue esigenze creative.',
        videoModels: 'Modelli di generazione di video AI',
        videoModelsDesc:
            'Esplora i nostri potenti modelli di generazione di video AI, da Google Veo a Seedance, per soddisfare le tue esigenze creative.',
        bannerImageDesc: 'Dai vita alla tua immaginazione.',
        bannerVideoCreateDesc: "Crea video cinematografici all'istante.",
        bannerMusicDesc: 'Crea la tua musica con un clic.',
        bannerCharacterDesc: 'Chatta con personaggi AI virtuali.',
        inspiration_title: 'Ispirazione',
        feed_hot: 'Ispirazione popolare',
        feed_latest: 'Ultima ispirazione',
        feed_hot_short: 'Popolare',
        feed_latest_short: 'Ultimo',
        load_more_inspiration: 'Vedi più ispirazione',
        inspiration_badge_video: 'Video',
        inspiration_badge_image: 'Immagine',
        sora2_desc: 'Generazione video AI fisicamente accurata',
        model: 'Modello',
    },
    ar: {
        hot_models: 'نماذج الذكاء الاصطناعي الشائعة',
        workbench_title: 'أنشئ كل ما تتخيله',
        image_create: 'إنشاء الصورة',
        video_create: 'إنشاء الفيديو',
        music_create: 'إنشاء الموسيقى',
        ugc_create: 'الشخصيات',
        ai_music: 'موسيقى AI',
        ai_tools: 'أدوات التحرير',
        expand: 'عرض الكل',
        collapse: 'طي',
        create: 'إنشاء',
        text_to_image: 'نص إلى صورة',
        text_to_image_desc: 'أدخل تعبيرًا لإنشاء صورة',
        try: 'جرب',
        free_try_now: 'جرب مجانا',
        new: 'جديد',
        audio: 'صوت',
        image: 'صورة',
        bannerVideoDesc1: 'محتوى فيديو مبتكر',
        bannerVideoDesc2: 'إنشاء فيديو عالي الجودة',
        bannerVideoDesc3: 'محتوى فيديو مبتكر',
        bannerVideoDesc4: 'إنشاء فيديو متقدم باستخدام الذكاء الاصطناعي',
        imageModels: 'موديلات إنشاء الصور الذكائية',
        imageModelsDesc:
            'استكشف موديلاتنا القوية لإنشاء الصور الذكائية، من Nano banana إلى Sora2، لتلبية إحتياجاتك الإبداعية.',
        videoModels: 'موديلات إنشاء الفيديو الذكائية',
        videoModelsDesc:
            'استكشف موديلاتنا القوية لإنشاء الفيديو الذكائية، من Google Veo إلى Seedance، لتلبية إحتياجاتك الإبداعية.',
        bannerImageDesc: 'حوّل خيالك إلى واقع',
        bannerVideoCreateDesc: 'أنشئ مقاطع فيديو سينمائية على الفور',
        bannerMusicDesc: 'أنشئ موسيقاك الخاصة بنقرة واحدة',
        bannerCharacterDesc: 'تحدث مع شخصيات ذكاء اصطناعي افتراضية',
        inspiration_title: 'الإلهام',
        feed_hot: 'الإلهام الشائع',
        feed_latest: 'أحدث الإلهام',
        feed_hot_short: 'شائع',
        feed_latest_short: 'أحدث',
        load_more_inspiration: 'عرض المزيد من الإلهام',
        inspiration_badge_video: 'فيديو',
        inspiration_badge_image: 'صورة',
        sora2_desc: 'إنشاء فيديو بالذكاء الاصطناعي دقيق فيزيائياً',
        model: 'نموذج',
    },
    // 泰语
    th: {
        hot_models: 'โมเดล AI ยอดนิยม',
        workbench_title: 'WeryAI: สร้างสรรค์ทุกสิ่งที่คุณจินตนาการ',
        image_create: 'สร้างภาพ',
        video_create: 'สร้างวิดีโอ',
        music_create: 'สร้างเพลง',
        ugc_create: 'ตัวละคร',
        ai_tools: 'ชุดเครื่องมือแก้ไข',
        expand: 'ดูทั้งหมด',
        collapse: 'ย่อ',
        create: 'สร้าง',
        text_to_image: 'ข้อความเป็นภาพ',
        text_to_image_desc: 'ป้อนข้อความเพื่อสร้างภาพ',
        model: 'โมเดล AI',
        sora2_desc: 'คำอธิบายโมเดล Sora2',
        try: 'ลอง',
        free_try_now: 'ทดลองใช้ฟรี',
        new: 'ใหม่',
        audio: 'เสียง',
        image: 'ภาพ',
        bannerVideoDesc1: 'การจำลองโลกและเสียงที่สมจริง',
        bannerVideoDesc2: 'การตัดต่อวิดีโอคุณภาพสูง',
        bannerVideoDesc3: 'เนื้อหาวิดีโอสร้างสรรค์',
        bannerVideoDesc4: 'การสร้างวิดีโอ AI ขั้นสูง',
        imageModels: 'โมเดลสร้างภาพ AI',
        imageModelsDesc:
            'สำรวจโมเดลสร้างภาพ AI ที่ทรงพลัง ตั้งแต่ Nano banana ถึง Sora2 เพื่อตอบสนองความต้องการสร้างสรรค์ของคุณ',
        videoModels: 'โมเดลสร้างวิดีโอ AI',
        videoModelsDesc:
            'สำรวจโมเดลสร้างวิดีโอ AI ที่ทรงพลัง ตั้งแต่ Google Veo ถึง Seedance เพื่อตอบสนองความต้องการสร้างสรรค์ของคุณ',
        bannerImageDesc: 'ทำให้จินตนาการของคุณเป็นจริง',
        bannerVideoCreateDesc: 'สร้างวิดีโอแบบภาพยนตร์ทันที',
        bannerMusicDesc: 'สร้างเพลงของคุณเองด้วยคลิกเดียว',
        bannerCharacterDesc: 'แชทกับตัวละคร AI เสมือน',
        inspiration_title: 'แรงบันดาลใจ',
        feed_hot: 'แรงบันดาลใจยอดนิยม',
        feed_latest: 'ล่าสุด',
        feed_hot_short: 'ยอดนิยม',
        feed_latest_short: 'ล่าสุด',
        load_more_inspiration: 'ดูเพิ่มเติม',
        inspiration_badge_video: 'วิดีโอ',
        inspiration_badge_image: 'ภาพ',
    },
    // 丹麦语
    da: {
        hot_models: 'Populære AI-modeller',
        workbench_title: 'Skab alt, hvad du kan forestille dig',
        image_create: 'Generer billede',
        video_create: 'Generer video',
        music_create: 'Generer musik',
        ugc_create: 'Karakterer',
        ai_tools: 'Redigeringsværktøjer',
        expand: 'Se alle',
        collapse: 'Skjul',
        create: 'Opret',
        text_to_image: 'Tekst til billede',
        text_to_image_desc: 'Indtast prompt for at oprette et billede',
        model: 'AI-modeller',
        sora2_desc: 'Sora2 modelbeskrivelse',
        try: 'Prøv',
        free_try_now: 'Prøv gratis nu',
        new: 'Ny',
        audio: 'Lyd',
        image: 'Billede',
        bannerVideoDesc1: 'Realistisk verden og lydsimulering',
        bannerVideoDesc2: 'Videoredigering i høj kvalitet',
        bannerVideoDesc3: 'Kreativt videoindhold',
        bannerVideoDesc4: 'Avanceret AI-videoskabelse',
        imageModels: 'AI-billedmodeller',
        imageModelsDesc:
            'Udforsk kraftfulde AI-billedgenereringsmodeller, fra Nano banana til Sora2, for at opfylde dine kreative behov.',
        videoModels: 'AI-videomodeller',
        videoModelsDesc:
            'Udforsk kraftfulde AI-videogenereringsmodeller, fra Google Veo til Seedance, for at opfylde dine kreative behov.',
        bannerImageDesc: 'Bring din fantasi til live.',
        bannerVideoCreateDesc: 'Opret cinematiske videoer øjeblikkeligt.',
        bannerMusicDesc: 'Opret din egen musik med et klik.',
        bannerCharacterDesc: 'Chat med virtuelle AI-karakterer.',
        inspiration_title: 'Inspiration',
        feed_hot: 'Populær inspiration',
        feed_latest: 'Seneste inspiration',
        feed_hot_short: 'Populær',
        feed_latest_short: 'Seneste',
        load_more_inspiration: 'Se mere inspiration',
        inspiration_badge_video: 'Video',
        inspiration_badge_image: 'Billede',
    },
    // 挪威语
    no: {
        hot_models: 'Populære AI-modeller',
        workbench_title: 'WeryAI lar deg lage hva som helst du ønsker',
        image_create: 'Generer bilde',
        video_create: 'Generer video',
        music_create: 'Generer musikk',
        ugc_create: 'Karakterer',
        ai_tools: 'Redigeringsverktøy',
        expand: 'Se alle',
        collapse: 'Skjul',
        create: 'Opprett',
        text_to_image: 'Tekst til bilde',
        text_to_image_desc: 'Skriv inn prompt for å lage et bilde',
        model: 'AI-modeller',
        sora2_desc: 'Sora2 modellbeskrivelse',
        try: 'Prøv',
        free_try_now: 'Prøv gratis nå',
        new: 'Ny',
        audio: 'Lyd',
        image: 'Bilde',
        bannerVideoDesc1: 'Realistisk verden og lydsimulering',
        bannerVideoDesc2: 'Videoredigering av høy kvalitet',
        bannerVideoDesc3: 'Kreativt videoinnhold',
        bannerVideoDesc4: 'Avansert AI-videoskaping',
        imageModels: 'AI-bildemodeller',
        imageModelsDesc:
            'Utforsk kraftige AI-bildegenereringsmodeller, fra Nano banana til Sora2, for å møte dine kreative behov.',
        videoModels: 'AI-videomodeller',
        videoModelsDesc:
            'Utforsk kraftige AI-videogenereringsmodeller, fra Google Veo til Seedance, for å møte dine kreative behov.',
        bannerImageDesc: 'Gi liv til fantasien din.',
        bannerVideoCreateDesc: 'Lag filmatiske videoer umiddelbart.',
        bannerMusicDesc: 'Lag din egen musikk med ett klikk.',
        bannerCharacterDesc: 'Chat med virtuelle AI-karakterer.',
        inspiration_title: 'Inspirasjon',
        feed_hot: 'Populær inspirasjon',
        feed_latest: 'Siste inspirasjon',
        feed_hot_short: 'Populær',
        feed_latest_short: 'Siste',
        load_more_inspiration: 'Se mer inspirasjon',
        inspiration_badge_video: 'Video',
        inspiration_badge_image: 'Bilde',
    },
    // 荷兰语
    nl: {
        hot_models: 'Populaire AI-modellen',
        workbench_title: 'Creëer alles wat je je kunt voorstellen',
        image_create: 'Afbeelding genereren',
        video_create: 'Video genereren',
        music_create: 'Muziek genereren',
        ugc_create: 'Karakters',
        ai_tools: 'Bewerkingstools',
        expand: 'Bekijk alles',
        collapse: 'Inklappen',
        create: 'Maken',
        text_to_image: 'Tekst naar afbeelding',
        text_to_image_desc: 'Voer prompt in om een afbeelding te maken',
        model: 'AI-modellen',
        sora2_desc: 'Sora2 modelbeschrijving',
        try: 'Probeer',
        free_try_now: 'Gratis proberen',
        new: 'Nieuw',
        audio: 'Audio',
        image: 'Afbeelding',
        bannerVideoDesc1: 'Realistische wereld en audiosimulatie',
        bannerVideoDesc2: 'Hoogwaardige videobewerking',
        bannerVideoDesc3: 'Creatieve video-inhoud',
        bannerVideoDesc4: 'Geavanceerde AI-videocreatie',
        imageModels: 'AI-afbeeldingsmodellen',
        imageModelsDesc:
            'Ontdek krachtige AI-afbeeldingsgeneratiemodellen, van Nano banana tot Sora2, om aan je creatieve behoeften te voldoen.',
        videoModels: 'AI-videomodellen',
        videoModelsDesc:
            'Ontdek krachtige AI-videogeneratiemodellen, van Google Veo tot Seedance, om aan je creatieve behoeften te voldoen.',
        bannerImageDesc: 'Breng je verbeelding tot leven.',
        bannerVideoCreateDesc: 'Maak direct cinematische videos.',
        bannerMusicDesc: 'Maak je eigen muziek met één klik.',
        bannerCharacterDesc: 'Chat met virtuele AI-karakters.',
        inspiration_title: 'Inspiratie',
        feed_hot: 'Populaire inspiratie',
        feed_latest: 'Laatste inspiratie',
        feed_hot_short: 'Populair',
        feed_latest_short: 'Laatste',
        load_more_inspiration: 'Meer inspiratie bekijken',
        inspiration_badge_video: 'Video',
        inspiration_badge_image: 'Afbeelding',
    },
    // 印尼语
    id: {
        hot_models: 'Model AI Populer',
        workbench_title: 'WeryAI: Ciptakan apa pun yang Anda bayangkan.',
        image_create: 'Buat Gambar',
        video_create: 'Buat Video',
        music_create: 'Buat Musik',
        ugc_create: 'Karakter',
        ai_tools: 'Alat Pengeditan',
        expand: 'Lihat Semua',
        collapse: 'Ciutkan',
        create: 'Buat',
        text_to_image: 'Teks ke Gambar',
        text_to_image_desc: 'Masukkan prompt untuk membuat gambar',
        model: 'Model AI',
        sora2_desc: 'Deskripsi model Sora2',
        try: 'Coba',
        free_try_now: 'Coba Gratis Sekarang',
        new: 'Baru',
        audio: 'Audio',
        image: 'Gambar',
        bannerVideoDesc1: 'Simulasi dunia dan audio yang realistis',
        bannerVideoDesc2: 'Pengeditan video berkualitas tinggi',
        bannerVideoDesc3: 'Konten video kreatif',
        bannerVideoDesc4: 'Pembuatan video AI canggih',
        imageModels: 'Model Gambar AI',
        imageModelsDesc:
            'Jelajahi model generasi gambar AI yang kuat, dari Nano banana hingga Sora2, untuk memenuhi kebutuhan kreatif Anda.',
        videoModels: 'Model Video AI',
        videoModelsDesc:
            'Jelajahi model generasi video AI yang kuat, dari Google Veo hingga Seedance, untuk memenuhi kebutuhan kreatif Anda.',
        bannerImageDesc: 'Wujudkan imajinasi Anda.',
        bannerVideoCreateDesc: 'Buat video sinematik secara instan.',
        bannerMusicDesc: 'Buat musik Anda sendiri dengan satu klik.',
        bannerCharacterDesc: 'Ngobrol dengan karakter AI virtual.',
        inspiration_title: 'Inspirasi',
        feed_hot: 'Inspirasi populer',
        feed_latest: 'Inspirasi terbaru',
        feed_hot_short: 'Populer',
        feed_latest_short: 'Terbaru',
        load_more_inspiration: 'Lihat lebih banyak inspirasi',
        inspiration_badge_video: 'Video',
        inspiration_badge_image: 'Gambar',
    },
    // 土耳其语
    tr: {
        hot_models: 'Popüler AI Modelleri',
        workbench_title: 'Hayal ettiğiniz her şeyi yaratın',
        image_create: 'Görsel Oluştur',
        video_create: 'Video Oluştur',
        music_create: 'Müzik Oluştur',
        ugc_create: 'Karakterler',
        ai_tools: 'Düzenleme Araçları',
        expand: 'Tümünü Gör',
        collapse: 'Daralt',
        create: 'Oluştur',
        text_to_image: 'Metinden Görsele',
        text_to_image_desc: 'Görsel oluşturmak için prompt girin',
        model: 'AI Modelleri',
        sora2_desc: 'Sora2 model açıklaması',
        try: 'Dene',
        free_try_now: 'Şimdi Ücretsiz Dene',
        new: 'Yeni',
        audio: 'Ses',
        image: 'Görsel',
        bannerVideoDesc1: 'Gerçekçi dünya ve ses simülasyonu',
        bannerVideoDesc2: 'Yüksek kaliteli video düzenleme',
        bannerVideoDesc3: 'Yaratıcı video içeriği',
        bannerVideoDesc4: 'Gelişmiş AI video oluşturma',
        imageModels: 'AI Görsel Modelleri',
        imageModelsDesc:
            'Nano banana\'dan Sora2\'ye kadar güçlü AI görsel oluşturma modellerini keşfedin ve yaratıcı ihtiyaçlarınızı karşılayın.',
        videoModels: 'AI Video Modelleri',
        videoModelsDesc:
            'Google Veo\'dan Seedance\'e kadar güçlü AI video oluşturma modellerini keşfedin ve yaratıcı ihtiyaçlarınızı karşılayın.',
        bannerImageDesc: 'Hayal gücünüzü hayata geçirin.',
        bannerVideoCreateDesc: 'Anında sinematik videolar oluşturun.',
        bannerMusicDesc: 'Tek tıkla kendi müziğinizi oluşturun.',
        bannerCharacterDesc: 'Sanal AI karakterleriyle sohbet edin.',
        inspiration_title: 'İlham',
        feed_hot: 'Popüler ilham',
        feed_latest: 'En yeni ilham',
        feed_hot_short: 'Popüler',
        feed_latest_short: 'Yeni',
        load_more_inspiration: 'Daha fazla ilham görüntüle',
        inspiration_badge_video: 'Video',
        inspiration_badge_image: 'Görsel',
    },
}
